<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdProjectPlanPrpResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" withCustomRowActions
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-arrow-down"
                                               :disabled="actionDisabled('select')"
                                               custom-label="生成计划详情"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               confirm-text="确定要生成计划详情么？"
                                               :busy="onGenerate"
                                               @click="generatePpd()">
                                    </em-button>
                                    <em-button type="view"
                                               custom-label="查看项目计划详情"
                                               :disabled="actionDisabled('selectOne')"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="getCurrentScheduling()"
                                               :busy="viewScheduledResult"
                                    >
                                    </em-button>
                                    <em-button type="import"
                                               :disabled="actionDisabled('selectOne')"
                                               custom-label="项目计划排产" show-name
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :busy="onProjectScheduling"
                                               @click="popScheduleModal(2)"
                                    >
                                        <!--                             v-b-modal.modal-schedule>-->
                                    </em-button>
                                    <em-button type="import"
                                               :disabled="actionDisabled('selectOne')"
                                               custom-label="替换wbs号和network号"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               custom-icon="fa fa-fw fa-lg fa-refresh"
                                               :busy="onReplaceWbsAndNetwork"
                                               v-b-modal.modal-replaceWbsAndNetwork>
                                    </em-button>
                                    <em-button type="import" custom-icon="fa fa-suitcase"
                                               :disabled="actionDisabled('select')"
                                               custom-label="标准套生成虚拟工单"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :busy="onStandardGeneration"
                                               @click="handleStandardGenerate">
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-circle-o-notch"
                                               :disabled="actionDisabled('select')"
                                               custom-label="同步到项目计划"
                                               confirm-text="确认同步到项目计划？"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :busy="onUpdatePpScheduled"
                                               @click="updatePpScheduled()">
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-circle-o-notch"
                                               :disabled="actionDisabled('select')"
                                               custom-label="同步到pp"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :busy="onUpdateOmScheduled"
                                               @click="$refs.ifNeedInformPp.showModal()">
                                    </em-button>
                                    <!--                                    <em-button type="edit" custom-icon="fa fa-circle-o-notch"-->
                                    <!--                                               :disabled="actionDisabled('select')"-->
                                    <!--                                               custom-label="baseline"-->
                                    <!--                                               :showName="true"-->
                                    <!--                                               v-bind:class="'btn btn-outline-primary btn-sm'"-->
                                    <!--                                               :busy="onSetBaseline"-->
                                    <!--                                               confirm-text="确认设置baseline？"-->
                                    <!--                                               @click="setBaseline()">-->
                                    <!--                                    </em-button>-->
                                    <em-button type="edit" custom-icon="fa fa-circle-o-notch"
                                               :disabled="actionDisabled('select')"
                                               custom-label="冻结"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :busy="onFreeze"
                                               confirm-text="确认冻结项目计划？"
                                               @click="freeze()">
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-circle-o-notch"
                                               v-api-permission="['project-plan-thaw','edit']"
                                               :disabled="actionDisabled('select')"
                                               custom-label="解冻"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :busy="onThaw"
                                               confirm-text="确认解冻项目计划？"
                                               @click="thaw()">
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-circle-o-notch"
                                               :disabled="actionDisabled('select')"
                                               custom-label="同步到sap"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :busy="onSyncToSap"
                                               confirm-text="确认同步到sap？"
                                               @click="syncToSap()">
                                    </em-button>
                                </template>
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <!--                    <em-button type="gotoChild"-->
                                        <!--                               v-bind:class="'btn btn-outline-primary btn-sm'"-->
                                        <!--                               @click="gotoChild(row)">-->
                                        <!--                    </em-button>-->
                                        <em-button type="gotoChild"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   custom-label="调整记录"
                                                   custom-icon="fa fa-angle-down"
                                                   @click="popPdrp(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <b-modal id="modal-schedule" title="排产" hide-footer>
            <b-form @submit="handleScheduleSubmit" @reset="handleScheduleReset">
                <b-form-group
                    id="schedulingStrategy-group"
                    label="排产策略:"
                    label-for="input-schedulingStrategy"
                    invalid-feedback="必须选择排产策略"
                >
                    <b-form-select id="input-schedulingStrategy" v-model="schedulingForm.schedulingStrategy"
                                   :options="schedulingStrategyOptions"
                                   required></b-form-select>
                </b-form-group>
                <b-form-group
                    id="reSchedule-group"
                    label="刷新:"
                    label-for="input-reSchedule"
                >
                    <el-switch
                        style="display: block"
                        v-model="schedulingForm.reSchedule"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="重新排产">
                    </el-switch>
                </b-form-group>
                <b-form-group
                    id="beginTimePicker"
                    label="时间:"
                    label-for="input-beginTimePicker"
                >
                    <el-date-picker
                        v-model="beginTimeValue"
                        align="right"
                        type="date"
                        placeholder="选择开始日期">
                    </el-date-picker>
                    <el-date-picker
                        v-model="endTimeValue"
                        align="right"
                        type="date"
                        placeholder="选择结束日期">
                    </el-date-picker>
                </b-form-group>
                <b-row align-h="end" style="margin-top: 30px">
                    <b-button type="submit" variant="primary">排产</b-button>
                    <b-button type="reset" variant="danger">取消</b-button>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal id="modal-replaceWbsAndNetwork" title="替换wbs号和network号" hide-footer>
            <b-form @submit="handleReplaceWbsAndNetworkSubmit" @reset="handleReplaceWbsAndNetworkReset">
                <b-form-group
                    id="wbs-group"
                    label="wbs:"
                >
                    <b-form-input v-model="replaceWbsAndNetworkForm.wbs"></b-form-input>
                </b-form-group>
                <b-form-group
                    id="network-group"
                    label="network:"
                >
                    <b-form-input v-model="replaceWbsAndNetworkForm.network"></b-form-input>
                </b-form-group>
                <b-row align-h="end" style="margin-top: 30px">
                    <b-button type="submit" variant="primary">替换</b-button>
                    <b-button type="reset" variant="danger">取消</b-button>
                </b-row>
            </b-form>
        </b-modal>

        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <sub-entity-list ref="pdrpEntityList" sub-entity="sithMesPrdPdsrRPrpPdrp" editDisable
                         with-first-column
                         parent-field="pdrpIdPrp">
            <template #rowActionsFirstColumn="{row}">
                <b-button-group>
                    <em-button
                        type="gotoChild"
                        class="btn btn-outline-primary btn-sm"
                        customLabel="查看调整记录详情"
                        @click="gotoScheduleResultItemPage(row)">
                    </em-button>
                </b-button-group>
            </template>
        </sub-entity-list>

        <ReBModal ref="ifNeedInformPp"
                  @ok="updateOmScheduled()"
                  header="同步到PP">
            <b-form-checkbox
                class="w-100"
                v-model="needInformPp">
                需要通知PP
            </b-form-checkbox>
        </ReBModal>
    </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-05-23 09:53:55

import moment from "moment";
import emCommonListMixin from "@/mixin/em/common/list";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emCommonApiMixin from "@/mixin/em/common/api";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import subEntityList from "@/components/em/EmModal/SubEntityList";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    name: "sithMesPrdProjectPlanPrpListView",
    mixins: [emCommonListMixin, emCommonGotoMixin, emCommonApiMixin, emTableCheckedMixin],
    components: {ReBModal, subEntityList},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            onGenerate: false,
            onStandardGeneration: false,
            onProjectScheduling: false,
            onMainScheduling: false,
            onReplaceWbsAndNetwork: false,
            viewScheduledResult: false,
            onUpdatePpScheduled: false,
            onSyncToSap: false,
            onSetBaseline: false,
            onUpdateOmScheduled: false,
            onFreeze: false,
            onThaw: false,
            onNotifyEng: false,
            onUnpdateKam: false,
            schedulingForm: {
                prpIds: '',
                schedulingStrategy: 2,
                reSchedule: true,
                beginTime: null,
                endTime: null,
                planType: 2,  //1主计划，2项目计划
            },
            //对应后端：PrdPpSchedulingStrategyEnum
            schedulingStrategyOptions: [
                {value: '2', text: '正排'},
                {value: '3', text: '倒排'}
            ],
            beginTimeValue: '',
            endTimeValue: '',
            machineTypes: [],
            selectedMachineType: null,
            replaceWbsAndNetworkForm: {
                id: "",
                wbs: "",
                netWork: ""
            },
            needInformPp: false,
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"].join(",")
            // return this.$refs.emTable.checkedItems.join(",")
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"]
            // return this.$refs.emTable.checkedItems
        }
    },
    watch: {
        beginTimeValue(newValue) {
            this.schedulingForm.beginTime = moment(newValue).format(this.$t("em.datetime.format.viewMode"))
        }, endTimeValue(newValue) {
            this.schedulingForm.endTime = moment(newValue).format(this.$t("em.datetime.format.viewMode"))
        }
    },
    methods: {
        getCurrentScheduling() {
            this.viewScheduledResult = true
            //给选中记录id赋值
            this.schedulingForm.prpIds = this.selectIds
            //调用api
            this.$_emApiMixin_get(`${this.$_emApiMixin_entityBaseApi(this.modelName)}/ppd?ids=${this.selectIds}`)
                .then(response => {
                    //跳转到排产调整页面
                    this.$router.push({
                        name: 'projectPlanAdjust',
                        params: {
                            scheduledResult: response,
                            pageType: "list_a",
                            readOnly: true
                        }
                    })
                }).finally(result => this.viewScheduledResult = false)
        },
        handleScheduleSubmit(event) {
            event.preventDefault()
            //给选中记录id赋值
            this.schedulingForm.prpIds = this.selectIds
            let api = this.schedulingForm.reSchedule ? 'scheduling' : "scheduling/continue"
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/${api}`
            this.onProjectScheduling = true
            //调用api
            this.$_emApiMixin_post(url, this.schedulingForm.reSchedule ? this.schedulingForm : null)
                .then(response => {
                    // commonViewsUtil.showSuccess(this, "排产成功")
                    //跳转到排产调整页面
                    console.log("排产成功")
                    this.$router.push({
                        name: 'projectPlanAdjust',
                        params: {
                            scheduledResult: response.data,
                            pageType: this.schedulingForm.planType === 1 ? "edit_b" : "edit_a"
                        }
                    })
                }).finally(result => this.onProjectScheduling = false)
            this.$nextTick(() => {
                this.$bvModal.hide('modal-schedule')
            })
        },
        handleScheduleReset() {
            this.$nextTick(() => {
                this.$bvModal.hide('modal-schedule')
            })
        },
        popScheduleModal(planType) {
            this.beginTimeValue = this.$refs.emTable.checkedItemsRows[0].omForecastStartTime
            this.schedulingForm.planType = planType
            this.$bvModal.show('modal-schedule')
        },
        actionDisabled(type) {
            // 删除按钮在一条记录都没选的时候禁用
            if (type === "select") {
                return this.checkedItems && this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else if (type === "selectOne") {
                return this.checkedItems && this.checkedItems.length !== 1;
            }
        },
        generatePpd() {
            this.onGenerate = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/generationDetail?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "生成计划成功")
                    // this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onGenerate = false)
        },
        updatePpScheduled() {
            this.onUpdatePpScheduled = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/updatePpScheduled?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "同步pp排产结果成功")
                    // this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onUpdatePpScheduled = false)
        },
        syncToSap() {
            this.onSyncToSap = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/syncToSap?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "同步到sap成功")
                    // this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onSyncToSap = false)
        },
        setBaseline() {
            this.onSetBaseline = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/setBaseline?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "设置baseline成功")
                    this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onSetBaseline = false)

        },
        freeze() {
            this.onFreeze = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/freeze?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "冻结项目计划成功")
                    this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onFreeze = false)

        },
        thaw() {
            this.onThaw = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/thaw?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "解冻项目计划成功")
                    this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onThaw = false)

        },
        updateOmScheduled() {
            this.onUpdateOmScheduled = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/updateOmScheduled?ids=${this.selectIds}&needInformPp=${this.needInformPp}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "同步项目计划排产结果到pp成功")
                    // this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onUpdateOmScheduled = false)

        },
        handleStandardGenerate() {
            this.onStandardGeneration = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/standardGeneration?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "标准套生成虚拟工单工序成功")
                })
                .finally(() => this.onStandardGeneration = false)
        },
        handleStandardReset() {
            this.$nextTick(() => {
                this.$bvModal.hide('modal-standard')
            })
        },
        handleReplaceWbsAndNetworkSubmit(event) {
            event.preventDefault()
            this.onReplaceWbsAndNetwork = true
            this.replaceWbsAndNetworkForm.id = this.selectIds
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/replaceWbsAndNetwork`
            this.$_emApiMixin_post(url, this.replaceWbsAndNetworkForm)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "替换wbs号和network号成功")
                    this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onReplaceWbsAndNetwork = false)

            this.$nextTick(() => {
                this.$bvModal.hide('modal-replaceWbsAndNetwork')
            })
        },
        handleReplaceWbsAndNetworkReset() {
            this.$nextTick(() => {
                this.$bvModal.hide('modal-replaceWbsAndNetwork')
            })
        },
        schedule() {
            this.onScheduling = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/scheduling?ids=${this.selectIds}`
            console.log(this.selectIds)
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "生成计划成功")
                    // this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onGenerate = false)

        }, gotoChild(row) {
            this.$_emGotoMixin_gotoHolderList("sithMesPrdProjectPlanDetailPpd"
                , {ppdIdPrpFilter: row.id}
                , {ppdIdPrp: row.id}, false, {}, "findTreeByFilter")
        },
        popPdrp(row) {
            this.$refs.pdrpEntityList.showModal(row.id)
        },

        getMachineTypes() {
            this.$_emApiMixin_findByFilter("sithMesMstMachineType", {})
                .then(data => {
                    this.machineTypes = data.map(m => {
                        return {value: m.id, text: m.name};
                    })
                })
        },
        gotoScheduleResultItemPage(row) {
            this.$store.commit('routeStore/setObject', {
                prpId: row.pdrpIdPrp,
                pdsrId: row.id
            })
            this.$_emGotoMixin_gotoHolderList('sithMesPrdPpdScheduledResultItemPsri',
                {psriIdPdsrFilter: row.id}, {psriIdPdsr: row.id}, false, {})
        },
    }
    ,
    mounted() {
        this.getMachineTypes()
        // const subscribeItem = {
        //   id: "headerNotification333",
        //   topic: "headerNotification333", callback: (responseBody) => {
        //     console.log("测试订阅成功")
        //   }
        // };
        // // 订阅点对点通知
        // this.$webSocket.subscribeToBroadcast(subscribeItem)
        // // 订阅广播消息
        // this.$webSocket.subscribeToPoint(subscribeItem)
    }
};
</script>

<style scoped>
.el-row {
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
}

.w-100 >>> .custom-control-label {
    width: 100% !important;
}
</style>
